/* PULMUR - coffee-to-water ratio calculator.
   All brew data lives in data-* attributes rendered by Liquid, so the merchant
   edits methods in the theme editor and this file never changes.
   ponytail: no URL state - "Copy recipe" covers sharing. Add ?m=&s=&w= if
   people start sharing links to specific recipes. */
(function () {
  var GRAMS_PER_TBSP = 5.3; // level tablespoon of ground coffee

  function round(n, step) {
    return Math.round(n / step) * step;
  }

  function fmt(n) {
    // whole numbers stay whole; otherwise one decimal
    return Math.abs(n - Math.round(n)) < 0.05 ? String(Math.round(n)) : n.toFixed(1);
  }

  function init(root) {
    var methodEl = root.querySelector("[data-calc-method]");
    var coffeeEl = root.querySelector("[data-calc-coffee]");
    var waterEl = root.querySelector("[data-calc-water]");
    var cupsEl = root.querySelector("[data-calc-cups]");
    var copyEl = root.querySelector("[data-calc-copy]");
    if (!methodEl || !coffeeEl || !waterEl) return;

    var cupMl = parseFloat(root.getAttribute("data-cup-ml")) || 240;
    var source = "water"; // which field the visitor last drove

    var out = {
      ratio: root.querySelector("[data-out-ratio]"),
      coffee: root.querySelector("[data-out-coffee]"),
      water: root.querySelector("[data-out-water]"),
      tbsp: root.querySelector("[data-out-tbsp]"),
      grind: root.querySelector("[data-out-grind]"),
      temp: root.querySelector("[data-out-temp]"),
      time: root.querySelector("[data-out-time]"),
      bloom: root.querySelector("[data-out-bloom]"),
      note: root.querySelector("[data-out-note]"),
      method: root.querySelector("[data-out-method]"),
      serve: root.querySelector("[data-out-serve]"),
      ylabel: root.querySelectorAll("[data-out-ylabel]")
    };

    function strength() {
      var picked = root.querySelector("[data-calc-strength]:checked");
      return picked ? parseFloat(picked.value) || 1 : 1;
    }

    function method() {
      return methodEl.options[methodEl.selectedIndex];
    }

    // One serving is not the same size for every method: an espresso is ~36 ml,
    // a Moka pot ~130, a mug of filter ~240. Without this the calculator happily
    // doses 106 g of coffee for "1 cup" of espresso.
    function serving() {
      return parseFloat(method().getAttribute("data-serve")) || cupMl;
    }

    function render() {
      var m = method();
      var base = parseFloat(m.getAttribute("data-ratio")) || 16;
      var ratio = base * strength();

      var coffee = parseFloat(coffeeEl.value) || 0;
      var water = parseFloat(waterEl.value) || 0;

      if (source === "coffee" && coffee > 0) {
        water = round(coffee * ratio, 5);
        waterEl.value = water;
      } else {
        if (water <= 0) water = serving() * 2;
        coffee = round(water / ratio, 0.5);
        coffeeEl.value = coffee;
      }

      var serve = serving();
      if (cupsEl) {
        var cups = water / serve;
        cupsEl.value = cups >= 1 ? Math.round(cups * 10) / 10 : cups.toFixed(1);
      }
      if (out.serve) out.serve.textContent = Math.round(serve);
      if (out.ylabel) {
        var yl = m.getAttribute("data-ylabel") || "Water";
        out.ylabel.forEach(function (el) { el.textContent = yl; });
      }

      if (out.ratio) out.ratio.textContent = "1 : " + fmt(ratio);
      if (out.coffee) out.coffee.innerHTML = fmt(coffee) + " <span>g</span>";
      if (out.water) out.water.innerHTML = fmt(water) + " <span>ml</span>";
      if (out.method) out.method.textContent = m.text;

      if (out.tbsp) {
        var tbsp = round(coffee / GRAMS_PER_TBSP, 0.5);
        out.tbsp.textContent =
          "No scale? That is about " + fmt(tbsp) + " level tablespoons of ground coffee.";
      }

      if (out.grind) out.grind.textContent = m.getAttribute("data-grind") || "Medium";
      if (out.temp) out.temp.textContent = m.getAttribute("data-temp") || "92-96 °C";
      if (out.time) out.time.textContent = m.getAttribute("data-time") || "3:00";

      if (out.bloom) {
        var bx = parseFloat(m.getAttribute("data-bloom")) || 0;
        out.bloom.textContent = bx > 0 ? round(coffee * bx, 5) + " ml, 30-45 s" : "Not needed";
      }
      if (out.note) out.note.textContent = m.getAttribute("data-note") || "";
    }

    coffeeEl.addEventListener("input", function () { source = "coffee"; render(); });
    waterEl.addEventListener("input", function () { source = "water"; render(); });
    methodEl.addEventListener("change", function () {
      var cups = Math.max(1, Math.round(parseFloat(cupsEl && cupsEl.value) || 1));
      waterEl.value = Math.round(cups * serving());
      source = "water";
      render();
    });

    root.querySelectorAll("[data-calc-strength]").forEach(function (el) {
      el.addEventListener("change", render);
    });

    root.querySelectorAll("[data-calc-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var cups = parseFloat(cupsEl && cupsEl.value) || 1;
        cups = Math.min(12, Math.max(1, Math.round(cups) + parseInt(btn.getAttribute("data-calc-step"), 10)));
        waterEl.value = Math.round(cups * serving());
        source = "water";
        render();
      });
    });

    if (cupsEl) {
      cupsEl.addEventListener("input", function () {
        var cups = parseFloat(cupsEl.value) || 0;
        if (cups > 0) {
          waterEl.value = Math.round(cups * serving());
          source = "water";
          render();
        }
      });
    }

    if (copyEl) {
      copyEl.addEventListener("click", function () {
        var m = method();
        var text = [
          "Pulmur brew recipe - " + m.text,
          "Coffee: " + coffeeEl.value + " g",
          "Water: " + waterEl.value + " ml",
          "Ratio: " + (out.ratio ? out.ratio.textContent : ""),
          "Grind: " + (m.getAttribute("data-grind") || ""),
          "Water temp: " + (m.getAttribute("data-temp") || ""),
          "Brew time: " + (m.getAttribute("data-time") || "")
        ].join("\n");
        var done = function () {
          var label = copyEl.textContent;
          copyEl.textContent = "Copied";
          setTimeout(function () { copyEl.textContent = label; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          done();
        }
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll("[data-pbt-calc]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Theme editor re-renders sections without a page load
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-pbt-calc]").forEach(init);
  });
})();
